import { useState } from 'react';
import useResource from './useResource';
import api from 'api';

export default function useInPersonEvents() {
	const RESOURCE_URL = '/api/v1/admin/in_person_events';

	const [participants, setParticipants] = useState([]);
	const [participantsMeta, setParticipantsMeta] = useState({
		page: 1,
		per_page: 10,
		num_pages: 0
	});
	const [isFetching, setFetching] = useState(false);

	const {
		create: createInPersonEvent,
		resource: inPersonEvent,
		resources: inPersonEvents,
		findMany: fetchInPersonEvents,
		findOne: fetchInPersonEvent,
		setResource: updateInPersonEventResource,
		update: updateInPersonEvent,
		destroy: destroyInPersonEvent,
		isLoading,
		isEmpty,
		handleChange
	} = useResource({
		url: RESOURCE_URL,
		name: 'event'
	});

	const fetchParticipants = async (eventId, params) => {
		setFetching(true);
		try {
			const res = await api.get(`${RESOURCE_URL}/${eventId}/participants`, {
				params: params
			});

			setParticipants(res.data);
			setParticipantsMeta(res.meta);
			setFetching(false);

			return res;
		} catch (e) {
			setFetching(false);

			return e;
		}
	};

	const exportCsv = async (eventId, params) => {
		setFetching(true);
		try {
			const res = await api.get(`${RESOURCE_URL}/${eventId}/export`, {
				params: params,
				responseType: 'blob'
			});

			if (res.size > 0) {
				return { data: res, status: 200 };
			} else {
				return { message: 'Unable to export, try again later', status: 422 };
			}
		} catch (e) {
			return { message: 'Unable to export, try again later', status: 422 };
		}
	};

	return {
		createInPersonEvent,
		inPersonEvent,
		isEmpty,
		isLoading,
		handleChange,
		fetchInPersonEvents,
		inPersonEvents,
		fetchInPersonEvent,
		updateInPersonEventResource,
		updateInPersonEvent,
		destroyInPersonEvent,
		fetchParticipants,
		participants,
		participantsMeta,
		isLoadingParticipants: isFetching,
		exportCsv
	};
}
